import { MultiSelectFilter } from "components/NewAdvancedSearch/filters/MultiSelectFilter";
import { OperatorSelect } from "components/NewAdvancedSearch/filters/OperatorSelect";
import {
  isPresenceOp,
  OPERATIONS,
  toWireOp,
} from "components/NewAdvancedSearch/filters/selectOperators";
import { SingleSelectFilter } from "components/NewAdvancedSearch/filters/SingleSelectFilter";

// A select descriptor encodes three independent axes: cardinality (`isSingle`,
// an explicit opt-in since selects are multiple by default), option source
// (`data` vs `queryFn`, resolved inside useSelectFilterOptions) and the
// operators it accepts (`operators`, absent for an `in`-only filter). This
// picks the component for the cardinality axis and adds the operator control;
// each component handles the source axis.
export function SelectFilter({ descriptor, value, onChange }) {
  const Component = descriptor.isSingle
    ? SingleSelectFilter
    : MultiSelectFilter;

  if (!descriptor.operators) {
    return (
      <Component descriptor={descriptor} value={value} onChange={onChange} />
    );
  }

  const op = toWireOp(value?.op);
  const operations = OPERATIONS.filter(o =>
    descriptor.operators.includes(o.value)
  );

  // The selection is kept across an operator change, so moving to a presence
  // operator and back restores the chips; the serializer ignores it meanwhile.
  const handleChangeOp = next =>
    onChange({
      ...value,
      op: next === "in" && descriptor.isSingle ? "is" : next,
    });

  return (
    <div className="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:gap-2">
      <OperatorSelect
        operations={operations}
        value={op}
        onChange={handleChangeOp}
      />
      {!isPresenceOp(op) && (
        <Component descriptor={descriptor} value={value} onChange={onChange} />
      )}
    </div>
  );
}
